export const filmCategories = [
  { id: 'all', label: '全部' },
  { id: 'drama', label: '剧情向' },
  { id: 'visual', label: '影像向' },
  { id: 'collab', label: '合作企划' },
  { id: 'anniv', label: '纪念企划' },
];

export const films = [
  {
    id: 'f1',
    title: '剧情向整理 · 都市篇',
    category: 'drama',
    categoryLabel: '剧情向',
    period: '近期',
    duration: '约 120 分钟',
    tags: ['都市', '情感'],
    summary:
      '以都市夜色为背景的剧情向整理，侧重人物关系的铺陈与叙事节奏，适合想先理清作品脉络的读者按顺序了解。',
    highlight: '叙事结构清晰，画面偏冷调，适合安静观看。',
  },
  {
    id: 'f2',
    title: '剧情向整理 · 古典篇',
    category: 'drama',
    categoryLabel: '剧情向',
    period: '近期',
    duration: '约 110 分钟',
    tags: ['古典', '慢节奏'],
    summary:
      '复古氛围更浓的一类整理条目，色调偏暖、节奏舒缓，重点在场景营造与细节，适合喜欢沉浸感的观众。',
    highlight: '暖色调与复古置景是主要看点。',
  },
  {
    id: 'f3',
    title: '影像向合集 · 写真氛围',
    category: 'visual',
    categoryLabel: '影像向',
    period: '本季',
    duration: '约 90 分钟',
    tags: ['氛围', '光影'],
    summary:
      '以氛围与光影为核心的影像合集，构图统一、节奏轻缓，弱化情节、强调画面，适合当作放空式的视觉浏览。',
    highlight: '光影与色调统一，适合作为风格参考。',
  },
  {
    id: 'f4',
    title: '影像向合集 · 城市漫游',
    category: 'visual',
    categoryLabel: '影像向',
    period: '本季',
    duration: '约 85 分钟',
    tags: ['外景', '日常'],
    summary:
      '以外景为主线的影像合集，记录街景与日常片段，观感轻松，适合想看点生活化画面的读者。',
    highlight: '外景占比高，画面自然放松。',
  },
  {
    id: 'f5',
    title: '合作企划整理 · 联名特辑',
    category: 'collab',
    categoryLabel: '合作企划',
    period: '阶段更新',
    duration: '约 100 分钟',
    tags: ['联名', '花絮'],
    summary:
      '与其他品牌或团队合作的企划整理，除主要呈现外还包含幕后花絮与访谈片段，信息量更偏幕后。',
    highlight: '含花絮与访谈，适合想看幕后内容的读者。',
  },
  {
    id: 'f6',
    title: '纪念企划整理 · 回顾特辑',
    category: 'anniv',
    categoryLabel: '纪念企划',
    period: '里程碑',
    duration: '约 130 分钟',
    tags: ['回顾', '合集'],
    summary:
      '以回顾为主线的纪念企划，把不同时期的代表方向串联起来，适合一次性了解整体风格变化。',
    highlight: '时间跨度大，适合当作入门总览。',
  },
];